import * as React from "react";
import { forwardRef } from "react";
const SvgItalicIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.5 3.75V6H9.1575L6.5925 12H4.5V14.25H10.5V12H8.8425L11.4075 6H13.5V3.75H7.5Z", fill: "#4555D6" }));
const ForwardRef = forwardRef(SvgItalicIcon);
export { ForwardRef as ReactComponent };
